export const podtracPalette = [
    "#27647c",
    "#0ddce7",
    "#a8000b",
    "#f58f0a",
    "#125804",
    "#5db349",
    "#441f60",
    "#986db5",
    "#243e52",
    "#89a4ba"
];
